import { render, staticRenderFns } from "./CasinoLanguageForm.vue?vue&type=template&id=630d6aeb&"
import script from "./CasinoLanguageForm.vue?vue&type=script&lang=js&"
export * from "./CasinoLanguageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports